<template>
  <!-- 홈페이지 유지보수 개발요청안 | 사이드 배너 표출 (서남아이에스 임현아, 2024-07-20) -->
  <div id="sidebanner" v-if="longItems.length > 0 || shortItems.length > 0" :style="{ top: bannerTop, left: bannerLeft }"
    style="position: absolute; width: 150px; margin: 10px 25px;">
    <!-- Long 배너 -->
    <div v-if="longItems.length > 0">
      <div class="side_bnr_log_url" v-if="(typeof longItems[0].url !== 'undefined') && (longItems[0].url.length > 0)"
        v-on:click="fnMoveURL(longItems[0].url)">
        <img :src="$ConstCode.getImagePath(longItems[0].imagePath, '720/')" alt="" />
      </div>
      <div class="side_bnr_log" v-else>
        <img :src="$ConstCode.getImagePath(longItems[0].imagePath, '720/')" alt="" />
      </div>
    </div>
    <!-- Long 배너 -->
    <!-- Short 배너 -->
    <div v-if="shortItems.length > 0">
      <div class="img_wrap_short_url"
        v-if="(typeof shortItems[0].url !== 'undefined') && (shortItems[0].url.length > 0)"
        v-on:click="fnMoveURL(shortItems[0].url)">
        <img :src="$ConstCode.getImagePath(shortItems[0].imagePath, '720/')" alt="" />
      </div>
      <div class="img_wrap_short" v-else>
        <img :src="$ConstCode.getImagePath(shortItems[0].imagePath, '720/')" alt="" />
      </div>
      <div v-if="shortItems.length > 1">
        <div class="img_wrap_short_url"
          v-if="(typeof shortItems[1].url !== 'undefined') && (shortItems[1].url.length > 0)"
          v-on:click="fnMoveURL(shortItems[1].url)">
          <img :src="$ConstCode.getImagePath(shortItems[1].imagePath, '720/')" alt="" />
        </div>
        <div class="img_wrap_short" v-else>
          <img :src="$ConstCode.getImagePath(shortItems[1].imagePath, '720/')" alt="" />
        </div>
      </div>
    </div>
    <!-- Short 배너 -->
  </div>
</template>
<script>
export default {
  name: 'SideBanner',
  props: {
    isURL: {
      type: [String],
      description: 'url 경로',
      default: () => false
    }
  },
  data: function () {
    return {
      params: {
        page: 1,
        limit: 10,
        site: 1,
        position: 'Side',
        sizeType: '',
        connectType: 1,
        menuType: '',
        isToday: 1
      },
      longItems: {
      },
      shortItems: {
      },
      siteUrl: ''
    }
  },
  async created() {
    await this.fnShowBanner()
  },
  watch: {
    // URL 은 같으나 표출 화면이 다른 경우 사용
    'isURL': async function () {
      await this.fnShowBanner()
    }
  },
  mounted() {
    // 창 크기 변경 시 이벤트 리스너 등록
    window.addEventListener('resize', this.setElementClass);
  },
  computed: {
    bannerTop() {
      return this.siteUrl === '0' ? '700px' : '400px';
    },
    bannerLeft() {
      if (window.innerWidth < 1400) {
        return '1300px';
      } else {
        return 'calc(50% + 1200px / 2)';
      }
    }
  },
  methods: {
    searchURL() {
      if (this.isURL === '/main') { this.siteUrl = '0' }
      else if (this.isURL === '/about/greeting') { this.siteUrl = '1' }
      else if (this.isURL === '/about/history') { this.siteUrl = '2' }
      else if (this.isURL === '/about/orgnz-chart') { this.siteUrl = '3' }
      else if (this.isURL === '/about/road') { this.siteUrl = '4' }
      else if (this.isURL === '/about/ci') { this.siteUrl = '5' }
      else if (this.isURL === '/hygn/notice') { this.siteUrl = '6' }
      else if (this.isURL === '/hygn/agency') { this.siteUrl = '7' }
      else if (this.isURL === '/manager/info') { this.siteUrl = '8' }
      else if (this.isURL === '/manager/edu/apply') { this.siteUrl = '9' }
      else if (this.isURL === '/manager/edu/apply/view') { this.siteUrl = '10' }
      else if (this.isURL === '/manager/edu/apply/write') { this.siteUrl = '11' }
      else if (this.isURL === '/manager/edu/apply/done') { this.siteUrl = '12' }
      else if (this.isURL === '/manager/edu/register') { this.siteUrl = '13' }
      else if (this.isURL === '/manager/edu/register/view') { this.siteUrl = '14' }
      else if (this.isURL === '/manager/exam/apply') { this.siteUrl = '15' }
      else if (this.isURL === '/manager/exam/apply/view') { this.siteUrl = '16' }
      else if (this.isURL === '/manager/exam/apply/write') { this.siteUrl = '17' }
      else if (this.isURL === '/manager/exam/apply/done') { this.siteUrl = '18' }
      else if (this.isURL === '/manager/exam/register') { this.siteUrl = '19' }
      else if (this.isURL === '/manager/exam/register/view') { this.siteUrl = '20' }
      else if (this.isURL === '/manager/exam/admission') { this.siteUrl = '21' }
      else if (this.isURL === '/manager/exam/notice') { this.siteUrl = '22' }
      else if (this.isURL === '/manager/exam/notice/view') { this.siteUrl = '23' }
      else if (this.isURL === '/manager/exam/certificate') { this.siteUrl = '24' }
      else if (this.isURL === '/manager/exam/pass') { this.siteUrl = '25' }
      else if (this.isURL === '/news/asctn') { this.siteUrl = '26' }
      else if (this.isURL === '/news/asctn/view') { this.siteUrl = '27' }
      else if (this.isURL === '/news/notice') { this.siteUrl = '28' }
      else if (this.isURL === '/news/notice/view') { this.siteUrl = '29' }
      else if (this.isURL === '/news/kfood') { this.siteUrl = '30' }
      else if (this.isURL === '/news/data') { this.siteUrl = '31' }
      else if (this.isURL === '/news/data/view') { this.siteUrl = '32' }
      else if (this.isURL === '/space/board') { this.siteUrl = '33' }
      else if (this.isURL === '/space/board/view') { this.siteUrl = '34' }
      else if (this.isURL === '/space/board/write') { this.siteUrl = '35' }
      else if (this.isURL === '/space/promotion') { this.siteUrl = '36' }
      else if (this.isURL === '/space/promotion/view') { this.siteUrl = '37' }
      else if (this.isURL === '/space/promotion/write') { this.siteUrl = '38' }
      else if (this.isURL === '/space/banner') { this.siteUrl = '39' }
      else if (this.isURL === '/sign/in') { this.siteUrl = '40' }
      else if (this.isURL === '/sign/find/id') { this.siteUrl = '41' }
      else if (this.isURL === '/sign/find/password/step1') { this.siteUrl = '42' }
      else if (this.isURL === '/sign/find/password/step2') { this.siteUrl = '43' }
      else if (this.isURL === '/sign/up/step1') { this.siteUrl = '44' }
      else if (this.isURL === '/sign/up/step2') { this.siteUrl = '45' }
    },
    async fnShowBanner() {
      // 배너 정보 가져오는 곳 (타입, 이미지, 이동 URL 등등)
      // Long 타입 불러오기
      this.searchURL()

      console.log('this.siteUrl')
      console.log(this.siteUrl)

      // this.params.limit = 1
      this.params.sizeType = 'L'
      this.params.menuType = this.siteUrl

      const res = await this.$BannerSvc.AdBannerList(this.params)
      if (res.entity.list && Array.isArray(res.entity.list)) {
        this.longItems = res.entity.list.slice(0, 1);
      }

      // this.params.limit = 2
      this.params.sizeType = 'S'

      const res2 = await this.$BannerSvc.AdBannerList(this.params)
      if (res2.entity.list && Array.isArray(res2.entity.list)) {
        this.shortItems = res2.entity.list.slice(0, 2)
      }
    },
    fnMoveURL: function (url) {
      window.location.href = url
    },
    setElementClass: function () {
      // 창 크기 줄여도 사이드 배너 잘 보이도록
      if (window.innerWidth < 1400) {
        document.getElementById('sidebanner').style.left = '1300px';
      } else {
        document.getElementById('sidebanner').style.left = 'calc(50% + 1200px / 2)';
      }
    }
  }
}
</script>
<style>
.side_bnr_log_url {
  width: 150px;
  height: 400px;
  cursor: pointer;
}

.side_bnr_log {
  width: 150px;
  height: 400px;
}

.img_wrap_short_url {
  width: 150px;
  height: 200px;
  cursor: pointer;
}

.img_wrap_short {
  width: 150px;
  height: 200px;
}

.side_bnr_log_url img,
.side_bnr_log img,
.img_wrap_short_url img,
.img_wrap_short img {
  width: 100%;
  height: 100%;
}
</style>
